// src/pages/profile/OrderHistoryPage.jsx
import React, { useEffect, useState } from 'react';
import { useAuth } from '../../hooks/useAuth';
import { collection, query, where, orderBy, getDocs } from 'firebase/firestore';
import { db } from '../../services/firebase';
import { Link } from 'react-router-dom';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import '../../styles/profile/OrderHistoryPage.css';

const OrderHistoryPage = () => {
  const { currentUser } = useAuth();
  const [orders, setOrders] = useState([]);
  const [loading, setLoading] = useState(true);
  const [fetchError, setFetchError] = useState(null);

  useEffect(() => {
    if (!currentUser) {
      setLoading(false);
      setFetchError("Please log in to view orders.");
      return;
    }

    const fetchOrders = async () => {
      setLoading(true);
      setFetchError(null);
      try {
        const q = query(
          collection(db, 'orders'),
          where('userId', '==', currentUser.uid),
          orderBy('createdAt', 'desc')
        );
        const snapshot = await getDocs(q);
        const ordersList = snapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data(),
          createdAt: doc.data().createdAt?.toDate() || new Date(),
        }));
        setOrders(ordersList);
        console.log("Fetched user orders:", ordersList); // Debug log
        if (ordersList.length === 0) {
          setFetchError("No orders found. Try placing a test order.");
        }
      } catch (err) {
        console.error('Error fetching orders:', err);
        setFetchError(`Failed to fetch orders: ${err.message}. Check console for details.`);
      } finally {
        setLoading(false);
      }
    };

    fetchOrders();
  }, [currentUser]);

  if (loading) return <LoadingSpinner />;

  return (
    <div className="order-history-page">
      <div className="container">
        <h1>Order History</h1>

        {fetchError && <p className="error-message">{fetchError}</p>}

        <div className="orders-list">
          {orders.length === 0 ? (
            <p className="no-orders">No orders yet. <Link to="/shop">Start shopping!</Link></p>
          ) : (
            orders.map(order => (
              <div key={order.id} className="order-card">
                <div className="order-header">
                  <span>Order #{order.id.slice(0, 8)}</span>
                  <span>{order.createdAt.toLocaleDateString()}</span>
                </div>

                <div className="order-items">
                  {order.items?.map((item, index) => (
                    <div key={index} className="order-item">
                      {item.imageUrl && (
                        <img src={item.imageUrl} alt={item.title} className="item-img" />
                      )}
                      <div>
                        <strong>{item.title}</strong>
                        <p>Qty: {item.quantity} × ${item.price?.toFixed(2)}</p>
                      </div>
                    </div>
                  )) || <p>No items</p>}
                </div>

                <div className="order-total">
                  <strong>Total: ${order.total.toFixed(2)} CAD</strong>
                </div>

                <div className="order-status">
                  Status: <span className={`status-badge ${order.status?.toLowerCase()}`}>
                    {order.status || 'Pending'}
                  </span>
                </div>
              </div>
            ))
          )}
        </div>
      </div>
    </div>
  );
};

export default OrderHistoryPage;